<style type="text/css">
  .position-sliders {
    padding-top: 4px;
  }
  .position-slider-row {
    display: flex;
    align-items: center;
    max-width: 350px;
    margin-left: 0;
    gap: 24px;
  }
  .position-slider-label {
    width: 90px;
    flex-shrink: 0;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
  .v-btn-toggle.square-alignment{
    overflow:hidden;
    flex-wrap: wrap;
    border:solid 1px rgba(0,0,0,.3);
    display:flex;
    width: 180px;
  }
  .v-btn-toggle.square-alignment>.v-btn{
      width:33%;
      flex-grow: 1;
      border: none;
      border-radius: 0 !important;
    }
</style>
<template>
    <div>
        <div><label class="v-label theme--light pr-4">{{label}}</label></div>
        <div v-if="hint" v-text="hint" />

        <div v-if="sliders" class="position-sliders">
            <div class="position-slider-row">
                <span class="position-slider-label">{{$translate('Horizontal')}}</span>
                <v-slider
                    :value="sliderX"
                    min="0"
                    max="100"
                    thumb-label
                    hide-details
                    color="zoezi-edit-color"
                    @end="onSliderEnd('x', $event)"
                />
            </div>
            <div class="position-slider-row">
                <span class="position-slider-label">{{$translate('Vertical')}}</span>
                <v-slider
                    :value="sliderY"
                    min="0"
                    max="100"
                    thumb-label
                    hide-details
                    color="zoezi-edit-color"
                    @end="onSliderEnd('y', $event)"
                />
            </div>
        </div>

        <v-btn-toggle v-else v-model="position" @change="$emit('input', position)" :mandatory="mandatory" color="zoezi-edit-color" class="square-alignment">
            <v-btn value="left top" small>
                <v-icon>mdi-arrow-top-left</v-icon>
            </v-btn>
            <v-btn value="center top" small>
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn value="right top" small>
                <v-icon>mdi-arrow-top-right</v-icon>
            </v-btn>
            <v-btn value="left center" small>
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn value="center center" small>
                <v-icon>mdi-image-filter-center-focus</v-icon>
            </v-btn>
            <v-btn value="right center" small>
                <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn value="left bottom" small>
                <v-icon>mdi-arrow-bottom-left</v-icon>
            </v-btn>
            <v-btn value="center bottom" small>
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <v-btn value="right bottom" small>
                <v-icon>mdi-arrow-bottom-right</v-icon>
            </v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'BackgroundPositionSetting',

    props: ['value', 'label', 'mandatory', 'hint', 'sliders'],

    data: () => ({
        position: null
    }),

    created() {
        this.position = this.value;
    },

    computed: {
        parsedValue() {
            const v = this.value;
            if (!v) return { x: 50, y: 50 };
            if (v.includes('%')) {
                const parts = v.trim().split(/\s+/);
                const x = parseFloat(parts[0]);
                const y = parseFloat(parts[1]);
                return { x: isNaN(x) ? 50 : x, y: isNaN(y) ? 50 : y };
            }
            // Handle old "left top" / "center center" preset format
            const [h = 'center', vert = 'center'] = v.trim().split(/\s+/);
            const hMap = { left: 0, center: 50, right: 100 };
            const vMap = { top: 0, center: 50, bottom: 100 };
            return { x: hMap[h] ?? 50, y: vMap[vert] ?? 50 };
        },
        sliderX() {
            return this.parsedValue.x;
        },
        sliderY() {
            return this.parsedValue.y;
        }
    },

    methods: {
        onSliderEnd(axis, val) {
            const pos = { ...this.parsedValue };
            pos[axis] = val;
            this.$emit('input', `${pos.x}% ${pos.y}%`);
        }
    }
}
</script>
